import React, { useState, useEffect, useContext } from "react";
import { ContextBoard } from "../../context/ContextBoard";
import { useNavigate } from "react-router-dom";
import Select from "react-select";

import Footer from "../shared/Footer";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import config from "../../config";
import Swal from "sweetalert2";
import { label } from "framer-motion/client";

function AddSchool() {
  const navigate = useNavigate();
  const token = sessionStorage.getItem("secondaryAdminToken");
  const [loading, setLoading] = useState(true);
  const [previewMode, setPreviewMode] = useState(false);
  const isDisabled = previewMode;

  const [stateList, setStateList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [blockList, setBlockList] = useState([]);
  const [subDivisionList, setSubDivisionList] = useState([]);

  const [typeOfSchoolOptions, setTypeOfSchoolOptions] = useState([]);

  const [class9limit, setClass9limit] = useState("");
  const [class10limit, setClass10limit] = useState("");
  const [class9limitspecialexam, setClass9limitspecialexam] = useState("");
  const [class10limitspecialexam, setClass10limitspecialexam] = useState("");

  const initialSchoolInfo = {
    schooL_CODE: "",
    udisE_CODE: "",
    schooL_NAME: "",
    sC_ADDRESS: "",
    piN_CODE: "",
    area: "",
    posT_OFFICE: "",
    nearesT_RAILWAY_STATION: "",
    challaN_LIMIT: "",
    challaN_LIMIT_CL_10: "",
    challaN_LIMIT_S_EXAM_CL_9: "",
    challaN_LIMIT_S_EXAM_CL_10: "",
    heaD_NAME: "",
    heaD_MOBILE_NO: "",
    emaiL_ADDRESS: "",
    asstistencE_TEACHER_CONTACT: "",
  };

  const [schoolInfo, setSchoolInfo] = useState(initialSchoolInfo);
  const [schoolInfoX, setSchoolInfoX] = useState({ ...initialSchoolInfo });

  const [selectedState, setSelectedState] = useState("");
  const [selectedStateX, setSelectedStateX] = useState("");
  const [typeofschool, setTypeofschool] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedDistrictX, setSelectedDistrictX] = useState("");
  const [selectedBlock, setSelectedBlock] = useState("");
  const [selectedBlockX, setSelectedBlockX] = useState("");
  const [selectedSubDivision, setSelectedSubDivision] = useState("");
  const [selectedSubDivisionX, setSelectedSubDivisionX] = useState("");
  const [copyDirection, setCopyDirection] = useState("");
  const [udiseSource, setUdiseSource] = useState("");
  const [schoolCodeSource, setSchoolCodeSource] = useState("");
  const permissions = JSON.parse(sessionStorage.getItem("permissions") || "[]");

  const [errors, setErrors] = useState({});
  useEffect(() => {
    if (!permissions[7]?.caN_VIEW) {
      navigate("/secondary-admin-dashboard");
    }
  }, [permissions, navigate]);
  const toOptions = (list, valueKey, labelKey) =>
    list.map((item) => ({
      value: item[valueKey],
      label: item[labelKey],
    }));

  const fetchPageLoadSecondaryDataSchool = async () => {
    /* if (!secondaryAdminSchoolCode) {
            navigate("/secondary-admin-school-list");
            return;
        } */

    setLoading(true);
    try {
      const response = await fetch(
        `${config.API_BASE_URL}/PageLoadForInsertSchoolSecondary`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          // body: JSON.stringify({ schooL_CODE: secondaryAdminSchoolCode }),
          // body: JSON.stringify({ schooL_CODE: "11001" }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        const groupData = data.data;
        console.log("Group Data:", groupData);
        setStateList(groupData.stateList);
        setDistrictList(groupData.districtList);
        setBlockList(groupData.blockList);
        setSubDivisionList(groupData.divisionlist);
        setSchoolInfo([]);

        setTypeOfSchoolOptions(
          groupData.schoolType.map((t) => ({
            value: t.typE_OF_SCHOOL,
            label: t.typE_OF_SCHOOL,
          }))
        );
      } else {
        Swal.fire("Error", "Unable to fetch data", "error");
      }
    } catch (error) {
      Swal.fire("Error", error.message || "Something went wrong", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!token) {
      navigate("/secondary-admin");
    } else {
      fetchPageLoadSecondaryDataSchool();
    }
  }, []);

  const filteredDistricts = selectedState
    ? districtList.filter((d) => d.statE_CODE === selectedState.value)
    : [];
  const filteredBlocks = selectedDistrict
    ? blockList.filter((b) => b.disT_CODE === selectedDistrict.value)
    : [];
  const filteredSubDivisions = selectedDistrict
    ? subDivisionList.filter((s) => s.district === selectedDistrict.value)
    : [];

  const filteredDistrictsX = selectedStateX
    ? districtList.filter((d) => d.statE_CODE === selectedStateX.value)
    : [];
  const filteredBlocksX = selectedDistrictX
    ? blockList.filter((b) => b.disT_CODE === selectedDistrictX.value)
    : [];
  const filteredSubDivisionsX = selectedDistrictX
    ? subDivisionList.filter((s) => s.district === selectedDistrictX.value)
    : [];

  const nonCopyableFields = [
    "schooL_CODE",
    "udisE_CODE",
    "challaN_LIMIT",
    "challaN_LIMIT_CL_10",
    "challaN_LIMIT_S_EXAM_CL_9",
    "challaN_LIMIT_S_EXAM_CL_10",
  ];

  const handleSelectChange = (level, value) => {
    switch (level) {
      case "state":
        setSelectedState(value);
        setSelectedDistrict("");
        setSelectedBlock("");
        setSelectedSubDivision("");
        if (copyDirection === "9to10") {
          setSelectedStateX(value);
          setSelectedDistrictX("");
          setSelectedBlockX("");
          setSelectedSubDivisionX("");
        }
        break;
      case "district":
        setSelectedDistrict(value);
        setSelectedBlock("");
        setSelectedSubDivision("");
        if (copyDirection === "9to10") {
          setSelectedDistrictX(value);
          setSelectedBlockX("");
          setSelectedSubDivisionX("");
        }
        break;
      case "block":
        setSelectedBlock(value);
        if (copyDirection === "9to10") {
          setSelectedBlockX(value);
        }
        break;
      case "subdivision":
        setSelectedSubDivision(value);
        if (copyDirection === "9to10") {
          setSelectedSubDivisionX(value);
        }
        break;
      default:
        break;
    }
  };

  const handleSelectChangeX = (level, value) => {
    switch (level) {
      case "state":
        setSelectedStateX(value);
        setSelectedDistrictX("");
        setSelectedBlockX("");
        setSelectedSubDivisionX("");
        if (copyDirection === "10to9") {
          setSelectedState(value);
          setSelectedDistrict("");
          setSelectedBlock("");
          setSelectedSubDivision("");
        }
        break;
      case "district":
        setSelectedDistrictX(value);
        setSelectedBlockX("");
        setSelectedSubDivisionX("");
        if (copyDirection === "10to9") {
          setSelectedDistrict(value);
          setSelectedBlock("");
          setSelectedSubDivision("");
        }
        break;
      case "block":
        setSelectedBlockX(value);
        if (copyDirection === "10to9") {
          setSelectedBlock(value);
        }
        break;
      case "subdivision":
        setSelectedSubDivisionX(value);
        if (copyDirection === "10to9") {
          setSelectedSubDivision(value);
        }
        break;
      default:
        break;
    }
  };

  const copySchoolData = (direction) => {
    if (direction === "9to10") {
      setSchoolInfoX((prev) => ({
        ...prev,
        schooL_NAME: schoolInfo.schooL_NAME || "",
        sC_ADDRESS: schoolInfo.sC_ADDRESS || "",
        typE_OF_SCHOOL: schoolInfo.typE_OF_SCHOOL || "",
        piN_CODE: schoolInfo.piN_CODE || "",
        area: schoolInfo.area || "",
        posT_OFFICE: schoolInfo.posT_OFFICE || "",
        nearesT_RAILWAY_STATION: schoolInfo.nearesT_RAILWAY_STATION || "",
        heaD_NAME: schoolInfo.heaD_NAME || "",
        heaD_MOBILE_NO: schoolInfo.heaD_MOBILE_NO || "",
        emaiL_ADDRESS: schoolInfo.emaiL_ADDRESS || "",
        asstistencE_TEACHER_CONTACT: schoolInfo.asstistencE_TEACHER_CONTACT || "",
      }));
      setSelectedStateX(selectedState);
      setSelectedDistrictX(selectedDistrict);
      setSelectedBlockX(selectedBlock);
      setSelectedSubDivisionX(selectedSubDivision);
      setCopyDirection("9to10");
    } else if (direction === "10to9") {
      setSchoolInfo((prev) => ({
        ...prev,
        schooL_NAME: schoolInfoX.schooL_NAME || "",
        sC_ADDRESS: schoolInfoX.sC_ADDRESS || "",
        typE_OF_SCHOOL: schoolInfoX.typE_OF_SCHOOL || "",
        piN_CODE: schoolInfoX.piN_CODE || "",
        area: schoolInfoX.area || "",
        posT_OFFICE: schoolInfoX.posT_OFFICE || "",
        nearesT_RAILWAY_STATION: schoolInfoX.nearesT_RAILWAY_STATION || "",
        heaD_NAME: schoolInfoX.heaD_NAME || "",
        heaD_MOBILE_NO: schoolInfoX.heaD_MOBILE_NO || "",
        emaiL_ADDRESS: schoolInfoX.emaiL_ADDRESS || "",
        asstistencE_TEACHER_CONTACT: schoolInfoX.asstistencE_TEACHER_CONTACT || "",
      }));
      setSelectedState(selectedStateX);
      setSelectedDistrict(selectedDistrictX);
      setSelectedBlock(selectedBlockX);
      setSelectedSubDivision(selectedSubDivisionX);
      setCopyDirection("10to9");
    }
  };

  const clearSchoolData = (target) => {
    if (target === "10") {
      setSchoolInfoX((prev) => ({
        ...prev,
        schooL_NAME: "",
        sC_ADDRESS: "",
        typE_OF_SCHOOL: "",
        piN_CODE: "",
        area: "",
        posT_OFFICE: "",
        nearesT_RAILWAY_STATION: "",
        heaD_NAME: "",
        heaD_MOBILE_NO: "",
        emaiL_ADDRESS: "",
        asstistencE_TEACHER_CONTACT: "",
      }));
      setSelectedStateX("");
      setSelectedDistrictX("");
      setSelectedBlockX("");
      setSelectedSubDivisionX("");
    } else if (target === "9") {
      setSchoolInfo((prev) => ({
        ...prev,
        schooL_NAME: "",
        sC_ADDRESS: "",
        typE_OF_SCHOOL: "",
        piN_CODE: "",
        area: "",
        posT_OFFICE: "",
        nearesT_RAILWAY_STATION: "",
        heaD_NAME: "",
        heaD_MOBILE_NO: "",
        emaiL_ADDRESS: "",
        asstistencE_TEACHER_CONTACT: "",
      }));
      setSelectedState("");
      setSelectedDistrict("");
      setSelectedBlock("");
      setSelectedSubDivision("");
    }
  };

  const toggleCopyDirection = (direction) => {
    if (copyDirection === direction) {
      setCopyDirection("");
      if (direction === "9to10") {
        clearSchoolData("10");
      } else if (direction === "10to9") {
        clearSchoolData("9");
      }
      return;
    }
    copySchoolData(direction);
  };

  const handleInputChange = (e) => {
    const { name, value, dataset } = e.target;
    const formType = dataset?.formType || "9";
    let newValue = value;

    // Always ensure it's a string for safety
    if (typeof newValue !== "string") {
      newValue = String(newValue);
    }

    if (/[|]/.test(newValue)) return;
    if (/\s{2,}/.test(newValue)) return;

    if (name === "schooL_NAME" || name === "sC_ADDRESS") {
      if (/[|]/.test(newValue)) return;
      newValue = newValue.toUpperCase();
    }

    if (
      name === "typE_OF_SCHOOL" ||
      name === "heaD_NAME"
    ) {
      if (/[^a-zA-Z\s]/.test(newValue)) return;
      newValue = newValue.toUpperCase();
    }

    if (
      name === "schooL_CODE" ||
      name === "telephonE_NO" ||
      name === "piN_CODE" ||
      name === "heaD_MOBILE_NO" ||
      name === "asstistencE_TEACHER_CONTACT" ||
      name === "challaN_LIMIT" ||
      name === "challaN_LIMIT_CL_10" ||
      name === "challaN_LIMIT_S_EXAM_CL_9" ||
      name === "challaN_LIMIT_S_EXAM_CL_10"
    ) {
      if (/[^0-9]/.test(newValue)) return;

      if (
        (name === "telephonE_NO" ||
          name === "heaD_MOBILE_NO" ||
          name === "asstistencE_TEACHER_CONTACT") &&
        newValue.length > 10
      ) {
        return;
      }
      if (name === "piN_CODE" && newValue.length > 6) {
        return;
      }
      if (name === "udisE_CODE" && newValue.length > 15) {
        return;
      }
      if (name === "schooL_CODE" && newValue.length > 5) {
        return;
      }
    }

    if (
      name === "udisE_CODE" ||
      name === "posT_OFFICE" ||
      name === "nearesT_RAILWAY_STATION"
    ) {
      if (/[^a-zA-Z0-9\s]/.test(newValue)) return;
      newValue = newValue.toUpperCase();
    }

    if (name === "emaiL_ADDRESS") {
      newValue = newValue.toLowerCase();
    }
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }

    if (name === "udisE_CODE") {
      setSchoolInfo((prev) => ({ ...prev, udisE_CODE: newValue }));
      setSchoolInfoX((prev) => ({ ...prev, udisE_CODE: newValue }));
      if (!newValue.trim()) {
        setUdiseSource("");
      } else {
        setUdiseSource(formType);
      }
      return;
    }

    if (name === "schooL_CODE") {
      setSchoolInfo((prev) => ({ ...prev, schooL_CODE: newValue }));
      setSchoolInfoX((prev) => ({ ...prev, schooL_CODE: newValue }));
      if (!newValue.trim()) {
        setSchoolCodeSource("");
      } else {
        setSchoolCodeSource(formType);
      }
      return;
    }

    if (formType === "10") {
      setSchoolInfoX((prev) => ({ ...prev, [name]: newValue }));
      if (copyDirection === "10to9" && !nonCopyableFields.includes(name)) {
        setSchoolInfo((prev) => ({ ...prev, [name]: newValue }));
      }
      return;
    }

    setSchoolInfo((prev) => ({ ...prev, [name]: newValue }));
    if (copyDirection === "9to10" && !nonCopyableFields.includes(name)) {
      setSchoolInfoX((prev) => ({ ...prev, [name]: newValue }));
    }
  };

  const handlePreview = () => {
    const newErrors = {};
    const trimmed = (val) => String(val || "").trim();

    setLoading(true);

    setTimeout(() => {
      // Class IX UDISE / School Code
      const hasIXUdise = !!trimmed(schoolInfo.udisE_CODE);
      const hasIXSchoolCode = !!trimmed(schoolInfo.schooL_CODE);
      if (!hasIXUdise && !hasIXSchoolCode) {
        newErrors.udisE_CODE = "Either UDISE Code or School Code is required.";
      } else {
        if (hasIXUdise && schoolInfo.udisE_CODE.length > 15) {
          newErrors.udisE_CODE = "Class IX UDISE code cannot exceed 15 characters.";
        }
        if (hasIXSchoolCode && schoolInfo.schooL_CODE.length !== 5) {
          newErrors.schooL_CODE = "Class IX School code must be exactly 5 characters.";
        }
      }

      // Class X UDISE / School Code
      const hasXUdise = !!trimmed(schoolInfoX.udisE_CODE);
      const hasXSchoolCode = !!trimmed(schoolInfoX.schooL_CODE);
      if (!hasXUdise && !hasXSchoolCode) {
        newErrors.udisE_CODEX = "Either UDISE Code or School Code is required.";
      } else {
        if (hasXUdise && schoolInfoX.udisE_CODE.length > 15) {
          newErrors.udisE_CODEX = "Class X UDISE code cannot exceed 15 characters.";
        }
        if (hasXSchoolCode && schoolInfoX.schooL_CODE.length !== 5) {
          newErrors.schooL_CODEX = "Class X School code must be exactly 5 characters.";
        }
      }

      // Class IX Required Fields
      if (!trimmed(schoolInfo.schooL_NAME))
        newErrors.schooL_NAME = "School name is required.";
      if (!trimmed(schoolInfo.sC_ADDRESS))
        newErrors.sC_ADDRESS = "School address is required.";
      if (!selectedState) newErrors.state = "State is required.";
      if (!selectedDistrict) newErrors.districtcode = "District is required.";
      if (!selectedBlock) newErrors.blocK_NAME = "Block is required.";
      if (!trimmed(schoolInfo.heaD_MOBILE_NO)) {
        newErrors.heaD_MOBILE_NO = "Principal mobile no is required.";
      } else if (schoolInfo.heaD_MOBILE_NO.length !== 10) {
        newErrors.heaD_MOBILE_NO = "Principal mobile no must be 10 digits.";
      }
      if (!trimmed(schoolInfo.emaiL_ADDRESS))
        newErrors.emaiL_ADDRESS = "Principal email is required.";

      // Class X Required Fields
      if (!trimmed(schoolInfoX.schooL_NAME))
        newErrors.schooL_NAMEX = "School name for Class X is required.";
      if (!trimmed(schoolInfoX.sC_ADDRESS))
        newErrors.sC_ADDRESSX = "School address for Class X is required.";
      if (!selectedStateX) newErrors.stateX = "State for Class X is required.";
      if (!selectedDistrictX) newErrors.districtcodeX = "District for Class X is required.";
      if (!selectedBlockX) newErrors.blocK_NAMEX = "Block for Class X is required.";
      if (!trimmed(schoolInfoX.heaD_MOBILE_NO)) {
        newErrors.heaD_MOBILE_NOX = "Principal mobile no for Class X is required.";
      } else if (schoolInfoX.heaD_MOBILE_NO.length !== 10) {
        newErrors.heaD_MOBILE_NOX = "Principal mobile no for Class X must be 10 digits.";
      }
      if (!trimmed(schoolInfoX.emaiL_ADDRESS))
        newErrors.emaiL_ADDRESSX = "Principal email for Class X is required.";

      if (schoolInfo.piN_CODE && schoolInfo.piN_CODE.length !== 6) {
        newErrors.piN_CODE = "Pin code must be exactly 6 digits.";
      }
      if (schoolInfoX.piN_CODE && schoolInfoX.piN_CODE.length !== 6) {
        newErrors.piN_CODEX = "Pin code must be exactly 6 digits.";
      }

      // Numbers or strings
      if (!trimmed(schoolInfo.challaN_LIMIT))
        newErrors.challaN_LIMIT =
          "Number of Challan Generation for class 9 is required.";
      if (!trimmed(schoolInfoX.challaN_LIMIT_CL_10))
        newErrors.challaN_LIMIT_CL_10 =
          "Number of Challan Generation for class 10 is required.";
      if (!trimmed(schoolInfo.challaN_LIMIT_S_EXAM_CL_9)) {
        newErrors.challaN_LIMIT_S_EXAM_CL_9 = "Number of Challan Generation for class 9 special exam is required.";
      }
      if (!trimmed(schoolInfoX.challaN_LIMIT_S_EXAM_CL_10)) {
        newErrors.challaN_LIMIT_S_EXAM_CL_10 = "Number of Challan Generation for class 10 special exam is required.";
      }

      if (
        schoolInfo.asstistencE_TEACHER_CONTACT &&
        schoolInfo.asstistencE_TEACHER_CONTACT.length !== 10
      ) {
        newErrors.asstistencE_TEACHER_CONTACT =
          "Asst. Teacher contact must be 10 digits.";
      }

      setErrors(newErrors);
      setLoading(false);

      if (Object.keys(newErrors).length === 0) {
        setPreviewMode(true);
      }
    }, 500);
  };

  const handleEdit = () => {
    setPreviewMode(false);
  };

  const handleSubmit = async () => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to save the changes?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Save it",
      cancelButtonText: "Cancel",
    });

    if (!confirm.isConfirmed) return;

    setLoading(true);

    const createdBy = sessionStorage.getItem("schoolCode") || "ADMIN";

    const hasClass9Data = !!(
      schoolInfo.schooL_CODE ||
      schoolInfo.udisE_CODE ||
      schoolInfo.schooL_NAME
    );
    const hasClass10Data = !!(
      schoolInfoX.schooL_CODE ||
      schoolInfoX.udisE_CODE ||
      schoolInfoX.schooL_NAME
    );

    const payload9 = {
      SCHOOL_CODE: schoolInfo.schooL_CODE || "",
      UDISE_CODE: schoolInfo.udisE_CODE || "",
      SCHOOL_NAME: schoolInfo.schooL_NAME || "",
      TYPE_OF_SCHOOL: typeofschool?.value || schoolInfo.typE_OF_SCHOOL || "",
      SC_ADDRESS: schoolInfo.sC_ADDRESS || "",
      STATE: selectedState?.value || schoolInfo.state || "",
      DISTRICT: selectedDistrict?.value || schoolInfo.district || "",
      BLOCK_NAME: selectedBlock?.value || schoolInfo.blocK_NAME || "",
      SUB_DIVISION: selectedSubDivision?.value || schoolInfo.suB_DIVISION || "",
      PIN_CODE: schoolInfo.piN_CODE || "",
      AREA: schoolInfo.area || "",
      POST_OFFICE: schoolInfo.posT_OFFICE || "",
      NEAREST_RAILWAY_STATION: schoolInfo.nearesT_RAILWAY_STATION || "",
      CHALLAN_LIMIT: Number(schoolInfo.challaN_LIMIT) || 0,
      HEAD_NAME: schoolInfo.heaD_NAME || "",
      HEAD_MOBILE_NO: schoolInfo.heaD_MOBILE_NO || "",
      EMAIL_ADDRESS: schoolInfo.emaiL_ADDRESS || "",
      ASSTISTENCE_TEACHER_CONTACT:
        schoolInfo.asstistencE_TEACHER_CONTACT || "",
      CREATED_BY: createdBy,
      CHALLAN_LIMIT_S_EXAM_CL_9:
        Number(schoolInfo.challaN_LIMIT_S_EXAM_CL_9) || 0,
    };

    const payload10 = {
      SCHOOL_CODE: schoolInfoX.schooL_CODE || "",
      UDISE_CODE: schoolInfoX.udisE_CODE || "",
      SCHOOL_NAME: schoolInfoX.schooL_NAME || "",
      TYPE_OF_SCHOOL: typeofschool?.value || schoolInfoX.typE_OF_SCHOOL || "",
      SC_ADDRESS: schoolInfoX.sC_ADDRESS || "",
      STATE: selectedStateX?.value || selectedState?.value || schoolInfoX.state || "",
      DISTRICT: selectedDistrictX?.value || selectedDistrict?.value || schoolInfoX.district || "",
      BLOCK_NAME: selectedBlockX?.value || selectedBlock?.value || schoolInfoX.blocK_NAME || "",
      SUB_DIVISION: selectedSubDivisionX?.value || selectedSubDivision?.value || schoolInfoX.suB_DIVISION || "",
      PIN_CODE: schoolInfoX.piN_CODE || "",
      AREA: schoolInfoX.area || "",
      POST_OFFICE: schoolInfoX.posT_OFFICE || "",
      NEAREST_RAILWAY_STATION: schoolInfoX.nearesT_RAILWAY_STATION || "",
      CHALLAN_LIMIT_CL_10: Number(schoolInfoX.challaN_LIMIT_CL_10) || 0,
      HEAD_NAME: schoolInfoX.heaD_NAME || "",
      HEAD_MOBILE_NO: schoolInfoX.heaD_MOBILE_NO || "",
      EMAIL_ADDRESS: schoolInfoX.emaiL_ADDRESS || "",
      ASSTISTENCE_TEACHER_CONTACT:
        schoolInfoX.asstistencE_TEACHER_CONTACT || "",
      CREATED_BY: createdBy,
      CHALLAN_LIMIT_S_EXAM_CL_10:
        Number(schoolInfoX.challaN_LIMIT_S_EXAM_CL_10) || 0,
    };

    const deleteFailedSchoolByClass = async (classType) => {
      const schoolCode =
        classType === "9"
          ? schoolInfo.schooL_CODE || ""
          : schoolInfoX.schooL_CODE || "";

      if (!schoolCode) return;

      const deleteUrl =
        classType === "9"
          ? `${config.API_BASE_URL}/Class9SchoolDeleteWhenErrorOccured_CL9`
          : `${config.API_BASE_URL2}/Class10SchoolDeleteWhenErrorOccured_CL10`;

      try {
        const deleteResponse = await fetch(deleteUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ schooL_CODE: schoolCode }),
        });

        if (!deleteResponse.ok) {
          console.error(`Delete cleanup failed for Class ${classType}`);
        }
      } catch (deleteErr) {
        console.error(`Delete cleanup request failed for Class ${classType}:`, deleteErr);
      }
    };

    try {
      let class9Success = false;
      let class10Success = false;

      if (hasClass9Data) {
        const response9 = await fetch(
          `${config.API_BASE_URL}/InsertSchoolData_CL9`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(payload9),
          }
        );

        const result9 = await response9.json();

        if (response9.ok && (result9.status === 200 || result9.status === "200" || result9.isSuccess)) {
          class9Success = true;
        } else {
          await deleteFailedSchoolByClass("9");
          setLoading(false);
          Swal.fire(
            "Class 9 Error",
            result9.message || "Failed to insert Class 9 school data",
            "error"
          );
          return;
        }
      }

      if (hasClass10Data) {
        const response10 = await fetch(
          `${config.API_BASE_URL2}/InsertSchoolData_CL10`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(payload10),
          }
        );

        const result10 = await response10.json();

        if (response10.ok && (result10.status === 200 || result10.status === "200" || result10.isSuccess)) {
          class10Success = true;
        } else {
          await deleteFailedSchoolByClass("10");
          setLoading(false);
          Swal.fire(
            "Class 10 Error",
            result10.message || "Failed to insert Class 10 school data",
            "error"
          );
          return;
        }
      }

      setLoading(false);

      if (hasClass9Data && hasClass10Data && class9Success && class10Success) {
        Swal.fire(
          "Success",
          "Successfully inserted both data",
          "success"
        ).then(() => {
          resetForm();
        });
      } else if (class9Success || class10Success) {
        Swal.fire(
          "Success",
          "School data inserted successfully",
          "success"
        ).then(() => {
          resetForm();
        });
      }
    } catch (err) {
      console.error(err);
      setLoading(false);
      Swal.fire("Error", "Something went wrong during submission", "error");
    }
  };

  const resetForm = () => {
    setSchoolInfo({
      schooL_CODE: "",
      udisE_CODE: "",
      schooL_NAME: "",
      sC_ADDRESS: "",
      piN_CODE: "",
      area: "",
      posT_OFFICE: "",
      nearesT_RAILWAY_STATION: "",
      challaN_LIMIT: "",
      challaN_LIMIT_CL_10: "",
      challaN_LIMIT_S_EXAM_CL_9: "",
      challaN_LIMIT_S_EXAM_CL_10: "",
      heaD_NAME: "",
      heaD_MOBILE_NO: "",
      emaiL_ADDRESS: "",
      asstistencE_TEACHER_CONTACT: "",
    });
    setSelectedState("");
    setSelectedDistrict("");
    setSelectedBlock("");
    setSelectedSubDivision("");
    setSelectedStateX("");
    setSelectedDistrictX("");
    setSelectedBlockX("");
    setSelectedSubDivisionX("");
    setSchoolInfoX({ ...initialSchoolInfo });
    setCopyDirection("");
    setTypeofschool("");
    setErrors({});
    setPreviewMode(false);
  };

  return (
    <div className="container-scroller">
      {loading && (
        <div className="custom-loader-container">
          <div className="custom-loader"></div>
        </div>
      )}
      <Navbar />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="row">
              <div className="col-md-12 mb-3">
                <section className="content-header">
                  <h1>
                    <i className="fa fa-university" />
                    &nbsp;Add School
                  </h1>
                  <ol className="breadcrumb">
                    <li>
                      <a
                        onClick={() => navigate("/secondary-admin-dashboard")}
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          className="fa fa-tachometer"
                          style={{ marginRight: "5px" }}
                        ></i>{" "}
                        Home
                      </a>
                    </li>
                    <li className="active">Secondary Admin Add School</li>
                  </ol>
                </section>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12 mb-4 stretch-card">
                <div className="card">
                  <div className="card-header d-flex justify-content-between align-items-center">
                    <h4 className="mb-0 p-2">Enter School Details for Class IX</h4>
                    <label className="mb-0 d-flex align-items-center gap-2" style={{ fontSize: 14, fontWeight: 600 }}>
                      <input
                        type="checkbox"
                        checked={copyDirection === "10to9"}
                        onChange={() => toggleCopyDirection("10to9")}
                      />
                      Copy from X to IX
                    </label>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      {/* Left side: School Info (col-md-9) */}
                      <div className="col-md-9">
                        <div className="row">
                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>
                                UDISE Code{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className={`form-control form-control-sm ${errors.udisE_CODE ? "is-invalid" : ""
                                  }`}
                                value={schoolInfo.udisE_CODE || ""}
                                name="udisE_CODE"
                                onChange={handleInputChange}
                                disabled={isDisabled || udiseSource === "10"}
                                maxLength={50}
                              />
                              {errors.udisE_CODE && (
                                <div className="text-danger mt-1 small">
                                  {errors.udisE_CODE}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group mb-3">
                              <label>
                                Name of School{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                name="schooL_NAME"
                                className={`form-control form-control-sm ${errors.schooL_NAME ? "is-invalid" : ""
                                  }`}
                                value={schoolInfo.schooL_NAME || ""}
                                onChange={handleInputChange}
                                disabled={isDisabled}
                                maxLength={150}
                              />
                              {errors.schooL_NAME && (
                                <div className="text-danger mt-1 small">
                                  {errors.schooL_NAME}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>Type of School</label>
                              <Select
                                value={typeofschool}
                                onChange={(selected) => {
                                  setTypeofschool(selected);
                                  setSchoolInfo((prev) => ({
                                    ...prev,
                                    typE_OF_SCHOOL: selected?.value || "",
                                  }));
                                }}
                                options={typeOfSchoolOptions}
                                isDisabled={isDisabled}
                                classNamePrefix="react-select"
                                placeholder="Select Type"
                              />
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>
                                School Code{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className={`form-control form-control-sm ${errors.schooL_CODE ? "is-invalid" : ""
                                  }`}
                                value={schoolInfo.schooL_CODE || ""}
                                name="schooL_CODE"
                                onChange={handleInputChange}
                                disabled={isDisabled || schoolCodeSource === "10"}
                                maxLength={5}
                              />
                              {errors.schooL_CODE && (
                                <div className="text-danger mt-1 small">
                                  {errors.schooL_CODE}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group mb-3">
                              <label>
                                School Address{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                name="sC_ADDRESS"
                                className={`form-control form-control-sm ${errors.sC_ADDRESS ? "is-invalid" : ""
                                  }`}
                                value={schoolInfo.sC_ADDRESS || ""}
                                onChange={handleInputChange}
                                disabled={isDisabled}
                                maxLength={150}
                              />
                              {errors.sC_ADDRESS && (
                                <div className="text-danger mt-1 small">
                                  {errors.sC_ADDRESS}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>
                                State <span className="text-danger">*</span>
                              </label>
                              <Select
                                options={toOptions(
                                  stateList,
                                  "statE_CODE",
                                  "statE_NAME"
                                )}
                                value={selectedState}
                                onChange={(val) =>
                                  handleSelectChange("state", val)
                                }
                                placeholder="Select State"
                                isDisabled={isDisabled}
                                className={errors.state ? "is-invalid" : ""}
                              />
                              {errors.state && (
                                <div className="text-danger mt-1 small">
                                  {errors.state}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>
                                District <span className="text-danger">*</span>
                              </label>
                              <Select
                                options={toOptions(
                                  filteredDistricts,
                                  "districT_CODE",
                                  "district"
                                )}
                                value={selectedDistrict}
                                onChange={(val) =>
                                  handleSelectChange("district", val)
                                }
                                isDisabled={!selectedState || isDisabled}
                                placeholder="Select District"
                                className={
                                  errors.districtcode ? "is-invalid" : ""
                                }
                              />
                              {errors.districtcode && (
                                <div className="text-danger mt-1 small">
                                  {errors.districtcode}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>
                                Block <span className="text-danger">*</span>
                              </label>
                              <Select
                                options={toOptions(
                                  filteredBlocks,
                                  "blocK_ID",
                                  "blocK_NAME"
                                )}
                                value={selectedBlock}
                                onChange={(val) =>
                                  handleSelectChange("block", val)
                                }
                                isDisabled={!selectedDistrict || isDisabled}
                                placeholder="Select Block"
                                className={
                                  errors.blocK_NAME ? "is-invalid" : ""
                                }
                              />
                              {errors.blocK_NAME && (
                                <div className="text-danger mt-1 small">
                                  {errors.blocK_NAME}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>Sub Division </label>
                              <Select
                                options={toOptions(
                                  filteredSubDivisions,
                                  "divisioN_ID",
                                  "divisioN_NAME"
                                )}
                                value={selectedSubDivision}
                                onChange={(val) =>
                                  handleSelectChange("subdivision", val)
                                }
                                isDisabled={!selectedDistrict || isDisabled}
                                placeholder="Select Subdivision"
                                className={
                                  errors.suB_DIVISION ? "is-invalid" : ""
                                }
                              />
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>Pin Code</label>
                              <input
                                type="text"
                                name="piN_CODE"
                                className={`form-control form-control-sm ${errors.piN_CODE ? "is-invalid" : ""
                                  }`}
                                inputMode="numeric"
                                pattern="[0-9]*"
                                value={schoolInfo.piN_CODE || ""}
                                onChange={handleInputChange}
                                disabled={isDisabled}
                                maxLength={6}
                              />
                              {errors.piN_CODE && (
                                <div className="text-danger mt-1 small">
                                  {errors.piN_CODE}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>Area</label>
                              <select
                                name="area"
                                className={`form-control form-select ${errors.area ? "is-invalid" : ""
                                  }`}
                                value={schoolInfo.area || ""}
                                onChange={handleInputChange}
                                disabled={isDisabled}
                              >
                                <option value="">Select</option>
                                <option value="RURAL">Rural</option>
                                <option value="URBAN">Urban</option>
                              </select>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>Post Office</label>
                              <input
                                type="text"
                                name="posT_OFFICE"
                                className={`form-control form-control-sm ${errors.posT_OFFICE ? "is-invalid" : ""
                                  }`}
                                value={schoolInfo.posT_OFFICE || ""}
                                onChange={handleInputChange}
                                disabled={isDisabled}
                                maxLength={50}
                              />
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>Nearest Railway Station </label>
                              <input
                                type="text"
                                name="nearesT_RAILWAY_STATION"
                                className={`form-control form-control-sm ${errors.nearesT_RAILWAY_STATION
                                  ? "is-invalid"
                                  : ""
                                  }`}
                                value={schoolInfo.nearesT_RAILWAY_STATION || ""}
                                onChange={handleInputChange}
                                disabled={isDisabled}
                                maxLength={50}
                              />
                              {errors.nearesT_RAILWAY_STATION && (
                                <div className="text-danger mt-1 small">
                                  {errors.nearesT_RAILWAY_STATION}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group mb-3">
                              <label>
                                Allowed Number of Challan Generation for class 9
                                <span className="text-danger">*</span>
                              </label>

                              <div className="d-flex align-items-center">
                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm"
                                  onClick={() => {
                                    const minValue = class9limit;
                                    if (
                                      (parseInt(schoolInfo.challaN_LIMIT) ||
                                        0) > minValue
                                    ) {
                                      handleInputChange({
                                        target: {
                                          name: "challaN_LIMIT",
                                          value:
                                            (parseInt(
                                              schoolInfo.challaN_LIMIT
                                            ) || 0) - 1,
                                        },
                                      });
                                    }
                                  }}
                                  disabled={isDisabled}
                                >
                                  −
                                </button>
                                <input
                                  type="number"
                                  name="challaN_LIMIT"
                                  className={`form-control form-control-sm mx-2 text-center ${errors.challaN_LIMIT ? "is-invalid" : ""
                                    }`}
                                  value={schoolInfo.challaN_LIMIT || ""}
                                  readOnly
                                  disabled={isDisabled}
                                  min={class9limit}
                                />
                                <button
                                  type="button"
                                  className="btn btn-success btn-sm"
                                  onClick={() => {
                                    handleInputChange({
                                      target: {
                                        name: "challaN_LIMIT",
                                        value:
                                          (parseInt(schoolInfo.challaN_LIMIT) ||
                                            0) + 1,
                                      },
                                    });
                                  }}
                                  disabled={isDisabled}
                                >
                                  +
                                </button>
                              </div>

                              {errors.challaN_LIMIT && (
                                <div className="text-danger mt-1 small">
                                  {errors.challaN_LIMIT}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group mb-3">
                              <label>
                                Allowed Number of Challan Generation for class
                                9 Special Exam
                                <span className="text-danger">*</span>
                              </label>

                              <div className="d-flex align-items-center">
                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm"
                                  onClick={() => {
                                    const minValue = class9limitspecialexam;
                                    if (
                                      (parseInt(
                                        schoolInfo.challaN_LIMIT_S_EXAM_CL_9
                                      ) || 0) > minValue
                                    ) {
                                      handleInputChange({
                                        target: {
                                          name: "challaN_LIMIT_S_EXAM_CL_9",
                                          value:
                                            (parseInt(
                                              schoolInfo.challaN_LIMIT_S_EXAM_CL_9
                                            ) || 0) - 1,
                                        },
                                      });
                                    }
                                  }}
                                  disabled={isDisabled}
                                >
                                  −
                                </button>

                                <input
                                  type="number"
                                  name="challaN_LIMIT_S_EXAM_CL_9"
                                  className={`form-control form-control-sm mx-2 text-center ${errors.challaN_LIMIT_S_EXAM_CL_9
                                    ? "is-invalid"
                                    : ""
                                    }`}
                                  value={schoolInfo.challaN_LIMIT_S_EXAM_CL_9 || ""}
                                  readOnly
                                  disabled={isDisabled}
                                  min={class9limitspecialexam}
                                />

                                <button
                                  type="button"
                                  className="btn btn-success btn-sm"
                                  onClick={() => {
                                    handleInputChange({
                                      target: {
                                        name: "challaN_LIMIT_S_EXAM_CL_9",
                                        value:
                                          (parseInt(
                                            schoolInfo.challaN_LIMIT_S_EXAM_CL_9
                                          ) || 0) + 1,
                                      },
                                    });
                                  }}
                                  disabled={isDisabled}
                                >
                                  +
                                </button>
                              </div>

                              {errors.challaN_LIMIT_S_EXAM_CL_9 && (
                                <div className="text-danger mt-1 small">
                                  {errors.challaN_LIMIT_S_EXAM_CL_9}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Right side: Principal Info (col-md-3) */}
                      <div
                        className="col-md-3"
                        style={{ borderLeft: "1px solid gray" }}
                      >
                        <div className="form-group mb-3">
                          <label>Principal Name </label>
                          <input
                            type="text"
                            name="heaD_NAME"
                            className={`form-control form-control-sm ${errors.heaD_NAME ? "is-invalid" : ""
                              }`}
                            value={schoolInfo.heaD_NAME || ""}
                            onChange={handleInputChange}
                            disabled={isDisabled}
                            maxLength={50}
                          />
                          {errors.heaD_NAME && (
                            <div className="text-danger mt-1 small">
                              {errors.heaD_NAME}
                            </div>
                          )}
                        </div>

                        <div className="form-group mb-3">
                          <label>
                            Principal Mobile No{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            name="heaD_MOBILE_NO"
                            className={`form-control form-control-sm ${errors.heaD_MOBILE_NO ? "is-invalid" : ""
                              }`}
                            inputMode="numeric"
                            pattern="[0-9]*"
                            value={schoolInfo.heaD_MOBILE_NO || ""}
                            onChange={handleInputChange}
                            disabled={isDisabled}
                            maxLength={10}
                          />
                          {errors.heaD_MOBILE_NO && (
                            <div className="text-danger mt-1 small">
                              {errors.heaD_MOBILE_NO}
                            </div>
                          )}
                        </div>

                        <div className="form-group mb-3">
                          <label>
                            Principal Email Address{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="email"
                            name="emaiL_ADDRESS"
                            className={`form-control form-control-sm ${errors.emaiL_ADDRESS ? "is-invalid" : ""
                              }`}
                            value={schoolInfo.emaiL_ADDRESS || ""}
                            onChange={handleInputChange}
                            disabled={isDisabled}
                            maxLength={100}
                          />
                          {errors.emaiL_ADDRESS && (
                            <div className="text-danger mt-1 small">
                              {errors.emaiL_ADDRESS}
                            </div>
                          )}
                        </div>

                        <div className="form-group mb-3">
                          <label>Assistant Teacher Mobile No</label>
                          <input
                            type="text"
                            name="asstistencE_TEACHER_CONTACT"
                            className={`form-control form-control-sm ${errors.asstistencE_TEACHER_CONTACT
                              ? "is-invalid"
                              : ""
                              }`}
                            inputMode="numeric"
                            pattern="[0-9]*"
                            value={schoolInfo.asstistencE_TEACHER_CONTACT || ""}
                            onChange={handleInputChange}
                            disabled={isDisabled}
                            maxLength={10}
                          />
                          {errors.asstistencE_TEACHER_CONTACT && (
                            <div className="text-danger mt-1 small">
                              {errors.asstistencE_TEACHER_CONTACT}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12 mb-4 stretch-card">
                <div className="card">
                  <div className="card-header d-flex justify-content-between align-items-center">
                    <h4 className="mb-0 p-2">Enter School Details for Class X</h4>
                    <label className="mb-0 d-flex align-items-center gap-2" style={{ fontSize: 14, fontWeight: 600 }}>
                      <input
                        type="checkbox"
                        checked={copyDirection === "9to10"}
                        onChange={() => toggleCopyDirection("9to10")}
                      />
                      Copy from IX to X
                    </label>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      {/* Left side: School Info (col-md-9) */}
                      <div className="col-md-9">
                        <div className="row">
                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>
                                UDISE Code{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className={`form-control form-control-sm ${errors.udisE_CODEX || errors.udisE_CODE ? "is-invalid" : ""}`}
                                value={schoolInfoX.udisE_CODE || ""}
                                name="udisE_CODE"
                                data-form-type="10"
                                onChange={handleInputChange}
                                disabled={isDisabled || udiseSource === "9"}
                                maxLength={50}
                              />
                              {(errors.udisE_CODEX || errors.udisE_CODE) && (
                                <div className="text-danger mt-1 small">{errors.udisE_CODEX || errors.udisE_CODE}</div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group mb-3">
                              <label>
                                Name of School{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                name="schooL_NAME"
                                className={`form-control form-control-sm ${errors.schooL_NAMEX ? "is-invalid" : ""}`}
                                value={schoolInfoX.schooL_NAME || ""}
                                data-form-type="10"
                                onChange={handleInputChange}
                                disabled={isDisabled}
                                maxLength={150}
                              />
                              {errors.schooL_NAMEX && (
                                <div className="text-danger mt-1 small">{errors.schooL_NAMEX}</div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>Type of School</label>
                              <Select
                                value={typeofschool}
                                onChange={(selected) => {
                                  setTypeofschool(selected);
                                  setSchoolInfoX((prev) => ({
                                    ...prev,
                                    typE_OF_SCHOOL: selected?.value || "",
                                  }));
                                }}
                                options={typeOfSchoolOptions}
                                isDisabled={isDisabled}
                                classNamePrefix="react-select"
                                placeholder="Select Type"
                              />
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>
                                School Code{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                className={`form-control form-control-sm ${errors.schooL_CODEX || errors.schooL_CODE ? "is-invalid" : ""}`}
                                value={schoolInfoX.schooL_CODE || ""}
                                name="schooL_CODE"
                                data-form-type="10"
                                onChange={handleInputChange}
                                disabled={isDisabled || schoolCodeSource === "9"}
                                maxLength={5}
                              />
                              {(errors.schooL_CODEX || errors.schooL_CODE) && (
                                <div className="text-danger mt-1 small">{errors.schooL_CODEX || errors.schooL_CODE}</div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group mb-3">
                              <label>
                                School Address{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                name="sC_ADDRESS"
                                className={`form-control form-control-sm ${errors.sC_ADDRESSX ? "is-invalid" : ""}`}
                                value={schoolInfoX.sC_ADDRESS || ""}
                                data-form-type="10"
                                onChange={handleInputChange}
                                disabled={isDisabled}
                                maxLength={150}
                              />
                              {errors.sC_ADDRESSX && (
                                <div className="text-danger mt-1 small">{errors.sC_ADDRESSX}</div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>
                                State <span className="text-danger">*</span>
                              </label>
                              <Select
                                options={toOptions(stateList, "statE_CODE", "statE_NAME")}
                                value={selectedStateX}
                                onChange={(val) => handleSelectChangeX("state", val)}
                                placeholder="Select State"
                                isDisabled={isDisabled}
                                className={errors.stateX ? "is-invalid" : ""}
                              />
                              {errors.stateX && (
                                <div className="text-danger mt-1 small">{errors.stateX}</div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>
                                District <span className="text-danger">*</span>
                              </label>
                              <Select
                                options={toOptions(filteredDistrictsX, "districT_CODE", "district")}
                                value={selectedDistrictX}
                                onChange={(val) => handleSelectChangeX("district", val)}
                                isDisabled={!selectedStateX || isDisabled}
                                placeholder="Select District"
                                className={errors.districtcodeX ? "is-invalid" : ""}
                              />
                              {errors.districtcodeX && (
                                <div className="text-danger mt-1 small">{errors.districtcodeX}</div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>
                                Block <span className="text-danger">*</span>
                              </label>
                              <Select
                                options={toOptions(filteredBlocksX, "blocK_ID", "blocK_NAME")}
                                value={selectedBlockX}
                                onChange={(val) => handleSelectChangeX("block", val)}
                                isDisabled={!selectedDistrictX || isDisabled}
                                placeholder="Select Block"
                                className={errors.blocK_NAMEX ? "is-invalid" : ""}
                              />
                              {errors.blocK_NAMEX && (
                                <div className="text-danger mt-1 small">{errors.blocK_NAMEX}</div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>Sub Division </label>
                              <Select
                                options={toOptions(filteredSubDivisionsX, "divisioN_ID", "divisioN_NAME")}
                                value={selectedSubDivisionX}
                                onChange={(val) => handleSelectChangeX("subdivision", val)}
                                isDisabled={!selectedDistrictX || isDisabled}
                                placeholder="Select Subdivision"
                                className={errors.suB_DIVISION ? "is-invalid" : ""}
                              />
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>Pin Code</label>
                              <input
                                type="text"
                                name="piN_CODE"
                                data-form-type="10"
                                className={`form-control form-control-sm ${errors.piN_CODEX ? "is-invalid" : ""
                                  }`}
                                inputMode="numeric"
                                pattern="[0-9]*"
                                value={schoolInfoX.piN_CODE || ""}
                                onChange={handleInputChange}
                                disabled={isDisabled}
                                maxLength={6}
                              />
                              {errors.piN_CODEX && (
                                <div className="text-danger mt-1 small">
                                  {errors.piN_CODEX}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>Area</label>
                              <select
                                name="area"
                                data-form-type="10"
                                className={`form-control form-select ${errors.area ? "is-invalid" : ""
                                  }`}
                                value={schoolInfoX.area || ""}
                                onChange={handleInputChange}
                                disabled={isDisabled}
                              >
                                <option value="">Select</option>
                                <option value="RURAL">Rural</option>
                                <option value="URBAN">Urban</option>
                              </select>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>Post Office</label>
                              <input
                                type="text"
                                name="posT_OFFICE"
                                data-form-type="10"
                                className={`form-control form-control-sm ${errors.posT_OFFICE ? "is-invalid" : ""
                                  }`}
                                value={schoolInfoX.posT_OFFICE || ""}
                                onChange={handleInputChange}
                                disabled={isDisabled}
                                maxLength={50}
                              />
                            </div>
                          </div>

                          <div className="col-md-3">
                            <div className="form-group mb-3">
                              <label>Nearest Railway Station </label>
                              <input
                                type="text"
                                name="nearesT_RAILWAY_STATION"
                                data-form-type="10"
                                className={`form-control form-control-sm ${errors.nearesT_RAILWAY_STATION
                                  ? "is-invalid"
                                  : ""
                                  }`}
                                value={schoolInfoX.nearesT_RAILWAY_STATION || ""}
                                onChange={handleInputChange}
                                disabled={isDisabled}
                                maxLength={50}
                              />
                              {errors.nearesT_RAILWAY_STATION && (
                                <div className="text-danger mt-1 small">
                                  {errors.nearesT_RAILWAY_STATION}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group mb-3">
                              <label>
                                Allowed Number of Challan Generation for class
                                10
                                <span className="text-danger">*</span>
                              </label>

                              <div className="d-flex align-items-center">
                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm"
                                  onClick={() => {
                                    const minValue = class10limit;
                                    const currentVal = parseInt(schoolInfoX.challaN_LIMIT_CL_10 || schoolInfo.challaN_LIMIT_CL_10) || 0;
                                    if (currentVal > minValue) {
                                      const newVal = currentVal - 1;
                                      handleInputChange({
                                        target: {
                                          name: "challaN_LIMIT_CL_10",
                                          value: newVal,
                                          dataset: { formType: "10" },
                                        },
                                      });
                                      setSchoolInfo((prev) => ({
                                        ...prev,
                                        challaN_LIMIT_CL_10: String(newVal),
                                      }));
                                    }
                                  }}
                                  disabled={isDisabled}
                                >
                                  −
                                </button>

                                <input
                                  type="number"
                                  name="challaN_LIMIT_CL_10"
                                  data-form-type="10"
                                  className={`form-control form-control-sm mx-2 text-center ${errors.challaN_LIMIT_CL_10
                                    ? "is-invalid"
                                    : ""
                                    }`}
                                  value={schoolInfoX.challaN_LIMIT_CL_10 || schoolInfo.challaN_LIMIT_CL_10 || ""}
                                  readOnly
                                  disabled={isDisabled}
                                  min={class10limit}
                                />

                                <button
                                  type="button"
                                  className="btn btn-success btn-sm"
                                  onClick={() => {
                                    const currentVal = parseInt(schoolInfoX.challaN_LIMIT_CL_10 || schoolInfo.challaN_LIMIT_CL_10) || 0;
                                    const newVal = currentVal + 1;
                                    handleInputChange({
                                      target: {
                                        name: "challaN_LIMIT_CL_10",
                                        value: newVal,
                                        dataset: { formType: "10" },
                                      },
                                    });
                                    setSchoolInfo((prev) => ({
                                      ...prev,
                                      challaN_LIMIT_CL_10: String(newVal),
                                    }));
                                  }}
                                  disabled={isDisabled}
                                >
                                  +
                                </button>
                              </div>

                              {errors.challaN_LIMIT_CL_10 && (
                                <div className="text-danger mt-1 small">
                                  {errors.challaN_LIMIT_CL_10}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group mb-3">
                              <label>
                                Allowed Number of Challan Generation for class
                                10 Special Exam
                                <span className="text-danger">*</span>
                              </label>

                              <div className="d-flex align-items-center">
                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm"
                                  onClick={() => {
                                    const minValue = class10limitspecialexam;
                                    const currentVal = parseInt(schoolInfoX.challaN_LIMIT_S_EXAM_CL_10 || schoolInfo.challaN_LIMIT_S_EXAM_CL_10) || 0;
                                    if (currentVal > minValue) {
                                      const newVal = currentVal - 1;
                                      handleInputChange({
                                        target: {
                                          name: "challaN_LIMIT_S_EXAM_CL_10",
                                          value: newVal,
                                          dataset: { formType: "10" },
                                        },
                                      });
                                      setSchoolInfo((prev) => ({
                                        ...prev,
                                        challaN_LIMIT_S_EXAM_CL_10: String(newVal),
                                      }));
                                    }
                                  }}
                                  disabled={isDisabled}
                                >
                                  −
                                </button>

                                <input
                                  type="number"
                                  name="challaN_LIMIT_S_EXAM_CL_10"
                                  data-form-type="10"
                                  className={`form-control form-control-sm mx-2 text-center ${errors.challaN_LIMIT_S_EXAM_CL_10
                                    ? "is-invalid"
                                    : ""
                                    }`}
                                  value={schoolInfoX.challaN_LIMIT_S_EXAM_CL_10 || schoolInfo.challaN_LIMIT_S_EXAM_CL_10 || ""}
                                  readOnly
                                  disabled={isDisabled}
                                  min={class10limitspecialexam}
                                />

                                <button
                                  type="button"
                                  className="btn btn-success btn-sm"
                                  onClick={() => {
                                    const currentVal = parseInt(schoolInfoX.challaN_LIMIT_S_EXAM_CL_10 || schoolInfo.challaN_LIMIT_S_EXAM_CL_10) || 0;
                                    const newVal = currentVal + 1;
                                    handleInputChange({
                                      target: {
                                        name: "challaN_LIMIT_S_EXAM_CL_10",
                                        value: newVal,
                                        dataset: { formType: "10" },
                                      },
                                    });
                                    setSchoolInfo((prev) => ({
                                      ...prev,
                                      challaN_LIMIT_S_EXAM_CL_10: String(newVal),
                                    }));
                                  }}
                                  disabled={isDisabled}
                                >
                                  +
                                </button>
                              </div>

                              {errors.challaN_LIMIT_S_EXAM_CL_10 && (
                                <div className="text-danger mt-1 small">
                                  {errors.challaN_LIMIT_S_EXAM_CL_10}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Right side: Principal Info (col-md-3) */}
                      <div
                        className="col-md-3"
                        style={{ borderLeft: "1px solid gray" }}
                      >
                        <div className="form-group mb-3">
                          <label>Principal Name </label>
                          <input
                            type="text"
                            name="heaD_NAME"
                            data-form-type="10"
                            className={`form-control form-control-sm ${errors.heaD_NAME ? "is-invalid" : ""
                              }`}
                            value={schoolInfoX.heaD_NAME || ""}
                            onChange={handleInputChange}
                            disabled={isDisabled}
                            maxLength={50}
                          />
                          {errors.heaD_NAME && (
                            <div className="text-danger mt-1 small">
                              {errors.heaD_NAME}
                            </div>
                          )}
                        </div>

                        <div className="form-group mb-3">
                          <label>
                            Principal Mobile No{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            name="heaD_MOBILE_NO"
                            data-form-type="10"
                            className={`form-control form-control-sm ${errors.heaD_MOBILE_NOX ? "is-invalid" : ""
                              }`}
                            inputMode="numeric"
                            pattern="[0-9]*"
                            value={schoolInfoX.heaD_MOBILE_NO || ""}
                            onChange={handleInputChange}
                            disabled={isDisabled}
                            maxLength={10}
                          />
                          {errors.heaD_MOBILE_NOX && (
                            <div className="text-danger mt-1 small">
                              {errors.heaD_MOBILE_NOX}
                            </div>
                          )}
                        </div>

                        <div className="form-group mb-3">
                          <label>
                            Principal Email Address{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="email"
                            name="emaiL_ADDRESS"
                            data-form-type="10"
                            className={`form-control form-control-sm ${errors.emaiL_ADDRESSX ? "is-invalid" : ""
                              }`}
                            value={schoolInfoX.emaiL_ADDRESS || ""}
                            onChange={handleInputChange}
                            disabled={isDisabled}
                            maxLength={100}
                          />
                          {errors.emaiL_ADDRESSX && (
                            <div className="text-danger mt-1 small">
                              {errors.emaiL_ADDRESSX}
                            </div>
                          )}
                        </div>

                        <div className="form-group mb-3">
                          <label>Assistant Teacher Mobile No</label>
                          <input
                            type="text"
                            name="asstistencE_TEACHER_CONTACT"
                            data-form-type="10"
                            className={`form-control form-control-sm ${errors.asstistencE_TEACHER_CONTACT
                              ? "is-invalid"
                              : ""
                              }`}
                            inputMode="numeric"
                            pattern="[0-9]*"
                            value={schoolInfoX.asstistencE_TEACHER_CONTACT || ""}
                            onChange={handleInputChange}
                            disabled={isDisabled}
                            maxLength={10}
                          />
                          {errors.asstistencE_TEACHER_CONTACT && (
                            <div className="text-danger mt-1 small">
                              {errors.asstistencE_TEACHER_CONTACT}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Action buttons */}
              <div className="col-md-12 stretch-card">
                <div className="card">
                  <div className="card-body">
                    {previewMode ? (
                      <>
                        <button
                          className="btn btn-primary me-2"
                          style={{ float: "right" }}
                          onClick={handleSubmit}
                        >
                          <i className="fa fa-save" /> Save
                        </button>
                        <button
                          className="btn btn-info me-2"
                          style={{ float: "right" }}
                          onClick={handleEdit}
                        >
                          <i className="fa fa-edit" /> Edit
                        </button>
                      </>
                    ) : (
                      <button
                        className="btn btn-secondary me-2"
                        style={{ float: "right" }}
                        onClick={handlePreview}
                      >
                        <i className="fa fa-eye" /> Preview
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default AddSchool;
